var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonBrown = function SvgPersonBrown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18542_22435",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18542_22435)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.62915 9.01758C8.28193 9.67036 9.06665 9.99674 9.98332 9.99674C10.9 9.99674 11.6847 9.67036 12.3375 9.01758C12.9903 8.3648 13.3166 7.58008 13.3166 6.66341C13.3166 5.74674 12.9903 4.96202 12.3375 4.30924C11.6847 3.65647 10.9 3.33008 9.98332 3.33008C9.06665 3.33008 8.28193 3.65647 7.62915 4.30924C6.97637 4.96202 6.64998 5.74674 6.64998 6.66341C6.64998 7.58008 6.97637 8.3648 7.62915 9.01758ZM3.31665 14.3301V16.6634H14.534C14.5051 16.5569 14.4922 16.4494 14.4922 16.3452V14.6099C14.174 14.5398 13.8867 14.3808 13.6473 14.1415C13.3155 13.8097 13.1381 13.3857 13.1381 12.9147V11.2705C12.9897 11.2283 12.8409 11.1891 12.6916 11.153C11.8028 10.9377 10.9 10.8301 9.98332 10.8301C9.06665 10.8301 8.16387 10.9377 7.27498 11.153C6.38609 11.3683 5.51109 11.6912 4.64998 12.1217C4.24721 12.3301 3.92429 12.6322 3.68123 13.028C3.43818 13.4238 3.31665 13.8579 3.31665 14.3301ZM13.9714 11.5408V12.9147C13.9714 13.1629 14.0598 13.3754 14.2366 13.5522C14.4134 13.729 14.6259 13.8174 14.8742 13.8174H15.3256V16.3452C15.3256 16.428 15.3481 16.4976 15.3933 16.554C15.4329 16.6035 15.4812 16.64 15.5382 16.6634H15.7964C15.8565 16.6388 15.9065 16.5967 15.9462 16.537L16.65 15.5196V14.3301C16.65 13.8579 16.5285 13.4238 16.2854 13.028C16.0423 12.6322 15.7194 12.3301 15.3166 12.1217C14.8719 11.8994 14.4235 11.7057 13.9714 11.5408Z",
    fill: "#652B19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5792 16.676C15.5115 16.6534 15.4551 16.6139 15.4099 16.5575C15.3648 16.5011 15.3422 16.4315 15.3422 16.3487V13.821H14.8908C14.6426 13.821 14.43 13.7326 14.2532 13.5558C14.0764 13.379 13.988 13.1665 13.988 12.9182V9.30707C13.988 9.05881 14.0764 8.84628 14.2532 8.66949C14.43 8.49269 14.6426 8.4043 14.8908 8.4043H17.5314C17.7722 8.4043 17.9659 8.49834 18.1126 8.68641C18.2593 8.87449 18.3026 9.08138 18.2424 9.30707L17.5991 11.564H18.107C18.3778 11.564 18.579 11.6844 18.7107 11.9251C18.8423 12.1659 18.8292 12.3991 18.6712 12.6248L15.9629 16.5406C15.9177 16.6083 15.8594 16.6534 15.788 16.676C15.7165 16.6986 15.6469 16.6986 15.5792 16.676Z",
    fill: "#652B19"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonBrown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Person-brown.a56486f4.svg";
export { ForwardRef as ReactComponent };